var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.657,
    height: 22.657,
    viewBox: "0 0 22.657 22.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.491 1.859)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.399,
    height: 3.643,
    rx: 1.821,
    transform: "translate(3.067 -1.859) rotate(45)",
    fill: "#a5a3a3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.399,
    height: 3.643,
    rx: 1.821,
    transform: "translate(0.491 18.222) rotate(-45)",
    fill: "#a5a3a3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.1744dcd587a348a573eaec3e815a075d.svg";
export { ForwardRef as ReactComponent };